import { useContext, useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom'
import { PATHS, TRANSACTION_TYPES } from '../../utils/constant';
import CustomTabs from '../custom/newTabs';
import MainDetails from './MainDetails';
import LineDetails from './LineDetails';
// import InitialDetails from './InitialDetails';
import Charges from './Charges';
import Totals from './Totals';
import { TStepsProps } from '../../Models/common';
import AddressTab from './AddressTab';
import { TransactionContext } from '../../contexts/TransactionContext';
import { NotificationContext } from '../../contexts/NotificationContext';
import StepNavigation from '../custom/StepNavigation';


function Inbound({ nextSection, nextButtonLable, path }: TStepsProps) {

    const navigate = useNavigate()
    const { capturedSteps } = useContext(TransactionContext)
    const { notify } = useContext(NotificationContext)
    const { id } = useParams()

    const goToNextSection = () => {
        if (!capturedSteps.includes('INBOUND'))
            return notify('Complete Inbound first.', 'error')

            if (id) navigate(path + '/' + id + '?section=' + nextSection)
            else navigate(path + '?section=' + nextSection)
    }


    return <>
        <InboundTabs goToNextStep={goToNextSection} />
        <div style={{paddingLeft:'10px', marginTop:'20px'}}>
            <StepNavigation
                capturedSteps={capturedSteps}
                currentSection='INBOUND'
                goToNextSection={goToNextSection}
                nextButtonLable={nextButtonLable}
            />
        </div>
    </>
}

function InboundTabs({goToNextStep}:{goToNextStep:()=>any}) {
    const [value, setValue] = useState(0);
    const navigate = useNavigate()
    const {transactionInfo:{transactionType}} = useContext(TransactionContext);

    const cancelInbound = () => {
        navigate(PATHS.CREATE_TRANSACTION)
    }

    return (
        <>
            <CustomTabs
                labels= {
                    transactionType !== TRANSACTION_TYPES.GMS ?
                    [
                        'Main Details',
                        'Line Details',
                        'Charges',
                        // 'Totals',
                        'Address'
                    ]
                    :
                    [
                        'Main Details',
                        'Line Details',
                        // 'Charges',
                        // 'Totals',
                        'Address'
                    ]
                }

                TabContents=
                { transactionType !== TRANSACTION_TYPES.GMS ?
                    [
                        <MainDetails goToNextTab={() => setValue(1)} goToNextStep={goToNextStep} />,
                        <LineDetails />,
                        <Charges />,
                        // <Totals />,
                        <AddressTab />
                    ]
                    :
                    [
                        <MainDetails goToNextTab={() => setValue(1)} goToNextStep={goToNextStep} />,
                        <LineDetails />,
                        // <Charges />,
                        // <Totals />,
                        <AddressTab />
                    ]
                }
                value={value}
                handleChange={setValue}
            />
            {/* <div style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '20px 10px 10px 30px' }}>
                <Button variant='outlined' type='button' color='secondary' onClick={cancelInbound} >{'Cancel Inbound'}</Button>
            </div> */}
        </>
    )
}

export default Inbound